import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import ChampFormulaire from '../../Common/ChampFormulaire';
import FormulaireModificationEntite from '../Utils/FormulaireModificationEntite';
import { HistoriqueLogs, Lieu } from '../../../../../common/src/entities';
import { DateTime } from 'luxon';
import { schemaLieu } from '../../../../../common/src/schemas';
import { useFormikContext } from 'formik';
import ChampsAssocies from '../Utils/ChampsAssociés';
import LogsLoader, { dateFormatter } from '../Utils/Log';
import { useGetQuery } from '../../../Utils/api';
import { LABEL_COL } from '../constantes';
import { MyPaper } from '../Utils/MyPaper';

export function affichageLieu(lieu: Lieu) {
    if (lieu) {
        return `${lieu.name ? lieu.name + ' - ' : ''}${lieu.adresse ? lieu.adresse : ''}${
            lieu.ville ? ', ' + lieu.ville : ''
        }${lieu.province ? ', ' + lieu.province : ''}${lieu.code_postal ? ', ' + lieu.code_postal : ''}`;
    }
    return '';
}

export function ChampsLieux(): ReactElement {
    const {
        values: { clients, activites, fournisseurs },
    } = useFormikContext<Lieu>();

    const client_combines = [
        ...(clients ?? []).map((c) => ({
            ...c.client,
            name: (
                <>
                    Lieu de <b>{c.client.name}</b>
                </>
            ),
        })),
    ];

    const fournisseurs_combines = [
        ...(fournisseurs ?? []).map((f) => ({
            ...f,
            name: (
                <>
                    Lieu de <b>{f.name}</b>
                </>
            ),
        })),
    ];

    const activite_combines = [
        ...(activites ?? []).map((a) => ({
            ...a.activite,
            name: (
                <>
                    Lieu de <b>{a.activite.name}</b>
                </>
            ),
        })),
    ];

    return (
        <MyPaper>
            <ChampFormulaire estPetit labelCol={LABEL_COL} id="name" titre="Nom" />
            <ChampFormulaire estPetit labelCol={LABEL_COL} id="adresse" titre="Adresse" />
            <ChampFormulaire estPetit labelCol={LABEL_COL} id="ville" titre="Ville" />
            <ChampFormulaire estPetit labelCol={LABEL_COL} id="province" titre="Province" />
            <ChampFormulaire estPetit labelCol={LABEL_COL} id="code_postal" titre="Code Postal" />
            <ChampFormulaire labelCol={LABEL_COL} id="notes" titre="Notes" textarea />
            <ChampsAssocies
                labelCol={LABEL_COL}
                items={fournisseurs_combines}
                url="fournisseurs"
                titre="Fournisseurs associés"
            />
            <ChampsAssocies
                labelCol={LABEL_COL}
                items={activite_combines}
                url="activites"
                titre="Activités associées"
            />
            <ChampsAssocies labelCol={LABEL_COL} items={client_combines} url="clients" titre="Clients associés" />
        </MyPaper>
    );
}

export default function DetailsLieu(): ReactElement {
    const { id } = useParams() as { id: string };
    const listLogs = useGetQuery<HistoriqueLogs[]>(`historique_logs/${id}/lieu`);
    return (
        <div>
            <FormulaireModificationEntite
                id={+id}
                entite={Lieu}
                badges={(l: Lieu) => [
                    `Lieu #${l.id}`,
                    `Créé: ${DateTime.fromISO(l.created_at).toRelativeCalendar()}`,
                    `Dernière modification: ${
                        listLogs.data?.[listLogs.data.length - 1]?.date_modification
                            ? dateFormatter(listLogs.data?.[listLogs.data.length - 1]?.date_modification)
                            : 'Aucune modificiation'
                    } par ${listLogs.data?.[listLogs.data.length - 1]?.nom_usager ?? ''}`,
                ]}
                schema={schemaLieu}
                properties_to_reassign={{
                    fournisseurs: null,
                    clients: null,
                    activites: null,
                }}
            >
                <ChampsLieux />
            </FormulaireModificationEntite>
            <LogsLoader id={id} tableName={'lieu'} />
        </div>
    );
}
